import { JournalistsPageLayout } from "../../pagelayouts/use-case/journalists";
import { useMarketingPagesTracking } from "../../hooks/marketingPagesTracking";
import { GoogleTagManagerScript } from "../../tracking/GoogleTagManager/GoogleTagManagerScript";

const Journalists = () => {
    useMarketingPagesTracking(true);

    return (
        <>
            <GoogleTagManagerScript />
            <JournalistsPageLayout />
        </>
    );
};

export async function getStaticProps() {
    return {
        props: {}
    };
}

export default Journalists;
